import { GameState } from '../../types/game-module.types';

export const state: GameState = {
  searchResults: [],
  activeGameReviews: [],
  activeGameRating: 0,
};
